import React from 'react';

const Toggle = React.forwardRef(({ name, value, text, checked, register }, ref) => {

    //name can be myLabels || printArticle || printOrder || myArticles || myOrders || pdfEnabled || pdfOnly 

    const id = `${name}${value || ''}`

    return (

        <div className="flex items-center justify-between">
           <label htmlFor={id} className="text-sm font-medium text-gray-700 dark:text-gray-300">{text}</label>
           <div className="relative inline-block w-12 mr-2 align-middle select-none transition duration-200 ease-in">
                <input 
                    type="checkbox" 
                    name={name} 
                    id={id}
                    ref={ref}
                    {...register(name)}
                    className="toggle-checkbox absolute block w-6 h-6 rounded-full bg-white border-2 border-gray-300 dark:border-gray-500 appearance-none cursor-pointer shadow-sm hover:shadow-md transition-all duration-200" 
                />
                <label htmlFor={id} className="toggle-label block overflow-hidden h-6 rounded-full bg-gray-300 dark:bg-gray-600 cursor-pointer border border-gray-300 dark:border-gray-500 shadow-sm hover:shadow-md transition-all duration-200"/>
            </div>
        </div>
    )
})

export default Toggle;
